<template>
  <div>
    <top-bar :title="dados ? `Pedido #${dados.id_contador}` : ''" event="true" @voltar="voltar()"/>
    <div class="container">
      <loading v-show="load" :fullscrean="true" text="Carregando os dados"/>
      <div class="mx-auto mb-5" style="max-width: 500px" v-if="dados">
        <div class="card px-3 pb-3 pt-4 mb-2">
          <div class="text-center">
            <!--
              Ilustrações de status temporariamente ocultas para manter esta tela
              alinhada à identidade visual do restante do app.
            <div class="sucesso" :class="`status-${dados.status}`">
              <img :src="base_cdn + `/static/imgs/icons/animated/double-check.gif`" v-if="dados.status === '4'"/>
              <img :src="base_cdn + `/static/imgs/icons/animated/letter-x.gif`" v-if="dados.status === '5'"/>
              <div v-else-if="dados.status === '3'">
                <img :src="base_cdn + `/static/imgs/icons/animated/route.gif`" v-if="dados.tipo_pedido === '1'"/>
                <img :src="base_cdn + `/static/imgs/icons/animated/food-pickup.gif`" v-else/>
              </div>
              <img :src="base_cdn + `/static/imgs/icons/animated/calendar.gif`" v-else-if="dados.data_agendamento"/>
              <div v-else>
                <img :src="base_cdn + `/static/imgs/icons/animated/bill.gif`" v-if="dados.status === '1'"/>
                <img :src="base_cdn + `/static/imgs/icons/animated/frying-pan.gif`" v-if="dados.status === '2'"/>
              </div>
            </div>
            -->

            <h6 v-if="dados.status_pagamento === '1'">Aguardando pagamento</h6>
            <h6 v-else-if="dados.status === '1'">{{ dados.data_agendamento ? 'Pedido agendado com sucesso!' : 'Aguardando confirmação' }}</h6>
            <h6 v-else-if="dados.status === '2'">{{ dados.data_agendamento ? 'Agendamento confirmado com sucesso!' : 'Estamos preparando seu pedido' }}</h6>
            <h6 v-else-if="dados.status === '3'">{{parseInt(dados.tipo_pedido) === 1 ? 'O pedido saiu para entrega' : 'Pedido disponível para retirada'}}</h6>
            <h6 v-else-if="dados.status === '4'">Pedido finalizado</h6>
            <div class="pedido-cancelado" v-else-if="dados.status === '5'">
              <div class="pedido-cancelado-icone">
                <i class="fa-solid fa-xmark" aria-hidden="true"></i>
              </div>
              <h6>Pedido cancelado</h6>
              <p>{{ dados.obs_cancelamento || 'Não informado' }}</p>
            </div>
            <div class="pedido-progresso mt-4 mb-3" v-if="dados.status !== '5' && dados.status_pagamento === '2'">
              <div
                class="pedido-etapa"
                :class="[
                  { concluida: parseInt(dados.status) > etapa.status, atual: parseInt(dados.status) === etapa.status },
                  `icone-${etapa.iconeSvg}`
                ]"
                v-for="etapa in etapasPedido"
                :key="etapa.status"
              >
                <div class="pedido-etapa-conteudo">
                  <div class="pedido-etapa-icone">
                    <icon :name="etapa.iconeSvg" size="22" aria-hidden="true"/>
                  </div>
                  <div class="pedido-etapa-label">{{ etapa.label }}</div>
                </div>
                <div
                  class="pedido-etapa-linha"
                  :class="{
                    concluida: parseInt(dados.status) > etapa.status,
                    carregando: parseInt(dados.status) === etapa.status
                  }"
                  v-if="etapa.status < etapasPedido.length"
                  :aria-label="parseInt(dados.status) === etapa.status ? 'Aguardando próxima etapa' : null"
                ></div>
              </div>
            </div>
            <hr v-else-if="dados.status !== '5'">
          </div>

          <div class="pedido-horarios" v-if="dados.status !== '5' && dados.status_pagamento === '2'">
            <div class="pedido-horario concluido">
              <span>Pedido realizado</span>
              <time>{{ dados.data_pedido }}</time>
            </div>
            <div class="pedido-horario" :class="{ concluido: dados.data_aceitacao }">
              <span>Pedido confirmado</span>
              <time>{{ dados.data_aceitacao || 'Aguardando' }}</time>
            </div>
            <div class="pedido-horario" :class="{ concluido: dados.data_entrega }" v-if="dados.status !== '4' || dados.data_entrega">
              <span>{{ parseInt(dados.tipo_pedido) === 1 ? 'Saiu para entrega' : 'Pronto para retirada' }}</span>
              <time>{{ dados.data_entrega || 'Aguardando' }}</time>
            </div>
            <button class="pedido-detalhes" @click="$refs.modalPedido.openModal(dados.id_pedido)">
              Ver Pedido <i class="fa fa-chevron-right ml-1"></i>
            </button>
          </div>

          <div class="pedido-horarios" v-if="dados.status === '5'">
            <div class="pedido-horario concluido">
              <span>Pedido realizado</span>
              <time>{{ dados.data_pedido }}</time>
            </div>
            <div class="pedido-horario concluido">
              <span>Pedido cancelado</span>
              <time>{{ dados.data_cancelamento || 'Não informado' }}</time>
            </div>
            <button class="pedido-detalhes" @click="$refs.modalPedido.openModal(dados.id_pedido)">
              Ver Pedido <i class="fa fa-chevron-right ml-1"></i>
            </button>
          </div>

          <div v-if="dados.status < 3 && dados.status_pagamento === '2'">
            <div class="border rounded-lg p-2 text-center mt-3">
              <div v-if="!dados.data_agendamento">
                <div v-show="parseInt(dados.status) >= 2">
                  <i class="fa fa-clock-o text-primary mr-1"></i>
                  Previsão {{parseInt(dados.tipo_pedido) === 1 ? "de entrega" : "para retirar o pedido"}}: <b>{{previsao}}</b>
                </div>
                <div class="small" v-if="dados.status === '1'">Previsão disponível após o pedido ser aprovado.</div>
              </div>
              <div class="small mb-0" v-else>
                <div>Pedido Agendado: <b>{{dados.data_agendamento}}</b></div>
                <div class="font-weight-bold" v-if="dados.status > '1'">O agendamento do seu pedido já foi confirmado.</div>
              </div>
            </div>
            <div class="mt-3" v-if="dados.descricao_pagamento">
              <aviso title="Detalhes do Pagamento" type="warning" icon="" centered>
                <div style="white-space: pre-line" v-html="dados.descricao_pagamento"></div>
              </aviso>
            </div>
          </div>

          <div class="text-center mt-4">
            <div class="mb-3" v-if="dados.status_pagamento === '1'">
              <div class="small mb-1">Realize o pagamento para o pedido ser confirmado.</div>
              <button class="btn btn-primary btn-block py-3" @click="pagarPedido(dados.id_pedido)" :disabled="load">
                Pagar Pedido
              </button>
            </div>
            <div class="whatsapp-alerta mb-3" v-else-if="hasWppAlert && dados.status < 4">
              <div class="font-weight-bold">Acompanhe seu pedido pelo WhatsApp</div>
              <div class="small mb-3">Clique abaixo e envie uma mensagem para ativar</div>
              <a href="javascript:" @click="enviarWhatsapp(1)" class="btn btn-success btn-block py-3">
                <i class="fa fa-whatsapp mr-1"></i> Acompanhar pelo WhatsApp
              </a>
            </div>
            <button
              class="btn btn-outline-dark btn-block pedido-detalhes-alternativo"
              @click="$refs.modalPedido.openModal(dados.id_pedido)"
              v-if="dados.status !== '5' && dados.status_pagamento !== '2'"
            >
              Ver Pedido <i class="fa fa-chevron-right ml-1"></i>
            </button>
          </div>
        </div>
        <div class="text-center mt-3" v-if="dados.chat_ativo === true">
          <button class="btn text-danger" @click="modalProblema = true">
            <i class="fa-solid fa-headset mr-1" aria-hidden="true"></i>
            Informar um Problema
          </button>
        </div>
      </div>
    </div>

    <modal-bottom :opened="modalProblema">
      <div class="container text-center" v-if="dados">
        <h5 class="font-weight-bold mt-2 mb-3">Problemas com seu pedido?</h5>
        <div class="mb-4">
          <div class="mb-4">Para cancelamentos, alterações ou reclamações, entre em contato com a gente:</div>
          <div class="mb-2" v-if="empresa.chat_lecard === '1'">
            <a href="#" class="btn btn-block btn-primary py-3" @click.prevent="openChat()">
              <i class="fa-solid fa-headset" aria-hidden="true"></i>
              <span class="ml-2">Fale com um atendente</span>
            </a>
          </div>
          <div class="mb-2" v-else-if="dados.whatsapp">
            <a href="javascript:" @click="enviarWhatsapp(2)" class="btn btn-success btn-block py-3">
              <i class="fa-brands fa-whatsapp mr-1" style="font-size: 20px" aria-hidden="true"></i>
              Chamar no WhatsApp
            </a>
          </div>
          <div class="mb-2" v-if="dados.telefone">
            <a :href="'tel:' + dados.telefone" class="btn btn-block btn-outline-primary py-3">
              <i class="fa-solid fa-phone mr-1" style="font-size: 20px" aria-hidden="true"></i>
              {{dados.telefone | phone}}
            </a>
          </div>
          <div v-if="dados.status === '1'">
            <button class="btn btn-outline-danger btn-block py-3" @click="cancelarPedido()" :disabled="load">
              {{load ? 'Cancelando o pedido..' : 'Cancelar o pedido'}}
            </button>
          </div>
        </div>
        <button type="button" class="btn btn-block p-3" @click="modalProblema = false">
          <span class="font-weight-bold text-primary">Voltar</span>
        </button>
      </div>
    </modal-bottom>

    <modal-pedido ref="modalPedido"/>
    <modal-chat ref="modalChat"/>

    <modal-bottom :opened="modalAlerta" v-if="!ignoraInteracao">
      <div class="container text-center mt-4">
        <h6 class="mb-3">Acompanhar pedido pelo WhatsApp?</h6>
        <p class="mb-4">
          Clique abaixo e envie uma mensagem no WhatsApp para acompanhar seu pedido
        </p>
        <div>
          <button class="btn btn-success btn-block p-3 mb-3" @click="enviarWhatsapp(1)">
            <i class="fa fa-whatsapp mr-1"></i> Enviar mensagem
          </button>
          <button type="button" class="btn btn-block p-3 mb-2" @click="modalAlerta = false">
            <span class="font-weight-bold text-primary">Não, obrigado</span>
          </button>
        </div>
      </div>
    </modal-bottom>

  </div>
</template>

<script>
  import TopBar from "../../../components/TopBar";
  import Icon from "../../../components/Icon";
  import Loading from "../../../components/Loading.vue";
  import ModalBottom from "../../../components/ModalBottom";
  import ModalChat from "../../../components/ModalChat.vue";
  import ModalPedido from "../../../components/ModalPedido.vue";
  import Aviso from "../../../components/Aviso.vue";

  export default {
    name: 'Sucesso',
    components: {Aviso, ModalChat, ModalPedido, Loading, ModalBottom, TopBar, Icon},
    data() {
      return {
        token: localStorage.getItem('token'),
        load: true,
        whatsapp: null,
        dados: null,
        url: '',
        modalAlerta: false,
        modalProblema: false,

        syncTimeout: null
      }
    },

    methods: {
      getPedidoId() {
        return this.dados?.id_pedido || this.$route.params?.pedido || null;
      },

      buscarPedido(id_pedido, callback, silencioso = false) {
        if (!this.token) {
          return;
        }

        const url = this.$helpers.base_url(this, this.empresa);

        if (!silencioso || !this.dados) {
          this.load = true;
          this.dados = null;
        }

        this.$http.get(url + this.token + '/pedido/status', { params: { id_pedido } })
          .then(response => {
            this.load = false;
            this.dados = response.data || null;

            if (this.dados.pontos) {
              this.pontosPedidos();
            }

            if (this.dados.status < 4) {
              this.pollingPedido();

            } else {
              this.stopPolling()
            }

            if (callback) callback();

          }, res => {
            this.load = false;

            if (!silencioso) {
              this.$swal(res.data?.msg || 'Erro ao buscar dados do pedido.');
            }
          });
      },

      pontosPedidos() {
        if (this.empresa.fidelidade && !sessionStorage.getItem('confetti')) {
          sessionStorage.setItem('confetti','true');
          this.iniciarConfetes();
          this.$swal({
            icon: 'https://lecard-cdn.nyc3.digitaloceanspaces.com/lecard-corporativo/static/imgs/confetti-80x80.png',
            title: 'Você ganhou Pontos!',
            text: 'Confira seu saldo e veja os benefícios disponíveis para resgate.',
            buttons: ["Voltar", "Ver meu Saldo"],
          }).then((r) => {
            if (r) {
              this.$store.state.saldoFidelidade = null;
              this.$router.push(this.url + '/promocoes');

            } else {
              this.$confetti.stop();
            }
          })
        }
      },

      iniciarConfetes() {
        const primaryColor = getComputedStyle(document.documentElement)
          .getPropertyValue('--lecard-primary')
          .trim();
        const colors = primaryColor
          ? [primaryColor]
          : ['#FF7900', '#FFC107', '#35A853', '#4285F4', '#A855F7'];

        this.$confetti.start({
          particles: [
            { type: 'rect', size: 8, dropRate: 5, colors },
            { type: 'circle', size: 5, dropRate: 3, colors }
          ],
          particlesPerFrame: 0.6,
          windSpeedMax: 0.35
        });
      },

      pagarPedido(id_pedido) {
        this.$router.push(this.url + '/pagamento/' + id_pedido);
      },

      cancelarPedido() {
        if (this.dados.whatsapp && !this.dados.id_entrega && this.dados.status_pagamento === '2') {
          this.$swal({
            text: 'Lamentamos a demora em aceitar o seu pedido! Quer nos enviar por WhatsApp?',
            buttons: ["Cancelar pedido", "Enviar por WhatsApp"],
            dangerMode: false,
          }).then((r) => {
            if (r) {
              this.enviarWhatsapp(3);

            } else {
              this.solicitarCancelamento();
            }
          });

        } else {
          this.solicitarCancelamento();
        }
      },

      solicitarCancelamento() {
        this.$swal({
          text: 'Deseja realmente cancelar o pedido?',
          buttons: ["Não", "Sim"],
          dangerMode: true,
        }).then((r) => {
          if (r) {
            this.cancelar();
          }
        });
      },

      cancelar() {
        if (!this.dados.id_pedido) {
          return;
        }

        const idPedido = this.dados.id_pedido;
        this.load = true;
        const url = this.$helpers.base_url(this, this.empresa);

        this.$http.post(url + this.token + '/meus-pedidos/cancelar', this.dados)
          .then(res => {
            if (res.data && res.data.success) {
              this.modalProblema = false;
              this.modalAlerta = false;
              this.buscarPedido(idPedido);
              this.$swal("Pedido cancelado com sucesso!");

            } else {
              this.load = false;
              let msg = res.data && res.data.msg ? res.data.msg : 'Erro temporário';
              this.$swal(msg);
            }

          }, res => {
            this.load = false;
            if (res.status === 401 && res.data.result !== '') {
              this.$swal(res.data.result + ' ' + res.data.msg).then(() => {
                this.$store.commit('logout');
                this.$router.push(this.url + '/perfil');
              });
            } else {
              let msg = res.data && res.data.msg ? res.data.msg : 'Erro temporário';
              this.$swal(msg);
            }
          });
      },

      enviarWhatsapp(tipoMsg) {
        let msg = `Acompanhar pedido #${this.dados.id_contador}`;
        this.modalAlerta = false;
        this.modalProblema = false;

        switch (tipoMsg) {
          case 2:
            msg = `# Olá, estou com um problema no pedido: ${this.dados.id_contador}. Poderia me ajudar por favor?`;
            break;

          case 3:
            msg = '# Olá, enviei um pedido mas ainda não foi confirmado. Poderia dar uma olhada por favor? \nPedido: *' + this.dados.id_contador + '* \nRealizado às: *' + this.dados.data_pedido + '* \n\nVia LeCard Delivery';
            break;
        }

        window.open('https://api.whatsapp.com/send?phone='+ this.whatsapp +'&text=' + window.encodeURIComponent(msg), '_blank');
      },

      openChat() {
        this.modalProblema = false;
        this.$refs.modalChat.openModal(this.dados.id_pedido);
      },

      pollingPedido() {
        this.stopPolling();

        this.syncTimeout = setTimeout(async () => {
          this.$http.get(`${this.server}polling-pedidos?id_cliente=${this.usuario.id_cliente}`)
            .then(response => {
              const idPedido = this.getPedidoId();

              if ((response.data || {}).success && idPedido) {
                this.buscarPedido(idPedido, null, true);
              }

            }, res => {
              // this.sincronizar();
            });

          this.pollingPedido(); // agenda o próximo ciclo
        }, 15000);
      },

      stopPolling() {
        if (this.syncTimeout) {
          clearInterval(this.syncTimeout);
          this.syncTimeout = null;
        }
      },

      handleVisibilityChange() {
        if (document.hidden) {
          console.log('document.hidden')
          this.stopPolling();

        } else {
          console.log('document.show')
          const idPedido = this.getPedidoId();

          if (idPedido) {
            this.buscarPedido(idPedido, null, true);
          }
        }
      },

      voltar() {
        this.$router.push(this.url + '/pedidos');
      }
    },

    mounted() {
      const id_pedido = this.$route.params?.pedido || '';

      if (!id_pedido || !this.token) {
        this.$router.push(this.url + '/');
        return;
      }

      this.url = this.$helpers.getUrlApp(this.$route.params.id || '');
      const hash = this.$route.hash ? this.$route.hash.replace('#', '') : `55${this.empresa.whatsapp}`;
      this.whatsapp = (hash || '');

      this.buscarPedido(id_pedido, () => {
        if (this.oneSignalIntegration) {
          this.$store.state.modalPush = this.$store.state.modalPush + 1;

        } else if (this.dados.status_pagamento === '2') {
          // this.modalAlerta = this.hasWppAlert;
        }
      });

      document.addEventListener("visibilitychange", this.handleVisibilityChange);
    },

    computed: {
      empresa() {
        return this.$store.state.empresa;
      },

      usuario() {
        return this.$store.state.dataUser
      },

      previsao() {
        return this.empresa.unidade_tempo !== '3' ? this.dados?.previsao.slice(-5) : `${this.dados?.previsao.substring(0, 10)}`;
      },

      ignoraInteracao() {
        return parseInt(this.empresa?.ignora_interacao || '0') === 1;
      },

      hasWppAlert() {
        return !this.ignoraInteracao && this.empresa.whatsapp && this.dados?.origin !== '5';
      },

      etapasPedido() {
        const entrega = parseInt(this.dados?.tipo_pedido) === 1;

        return [
          { status: 1, label: 'Recebido', iconeSvg: 'pedido' },
          { status: 2, label: 'Preparando', iconeSvg: 'local' },
          {
            status: 3,
            label: entrega ? 'A Caminho' : 'Retirada',
            iconeSvg: entrega ? 'delivery' : 'sacola'
          },
          { status: 4, label: entrega ? 'Entregue' : 'Finalizado', iconeSvg: 'success' }
        ];
      }
    },

    beforeDestroy() {
      this.stopPolling();
      document.removeEventListener("visibilitychange", this.handleVisibilityChange);
      if (this.$confetti) this.$confetti.stop();
    },

    filters: {
      phone(phone) {
        if (phone) {
          if (phone.length === 10) {
            return phone.replace(/[^0-9]/g, '')
                .replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');

          } else if (phone.length === 11) {
            return phone.replace(/[^0-9]/g, '')
                .replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
          }
        }

        return phone
      }
    }
  }
</script>
<style scoped>
.sucesso {
  width: 64px;
  height: 64px;
  margin: 0 auto 10px;
}
.sucesso img {
  width: 100%;
}
svg {
  fill: currentColor;
}
.pedido-progresso {
  align-items: flex-start;
  display: flex;
  padding: 0 4px;
}
.pedido-etapa {
  color: #cfd5da;
  display: flex;
  flex: 1;
  min-width: 0;
}
.pedido-etapa:last-child {
  flex: 0 0 44px;
}
.pedido-etapa-conteudo {
  flex: 0 0 44px;
  min-width: 0;
  position: relative;
  z-index: 1;
}
.pedido-etapa-linha {
  align-items: center;
  background: #e9ecef;
  border-radius: 4px;
  display: flex;
  flex: 1;
  height: 4px;
  justify-content: flex-end;
  margin: 22px -6px 0;
  min-width: 18px;
  overflow: hidden;
  position: relative;
}
.pedido-etapa-linha.concluida {
  background: var(--lecard-primary);
}
.pedido-etapa-linha.carregando {
  background: #e9ecef;
}
.pedido-etapa-linha.carregando::after {
  animation: pedido-linha-carregando 1.4s ease-in-out infinite alternate;
  background: linear-gradient(90deg, transparent, var(--lecard-primary) 25%, var(--lecard-primary) 75%, transparent);
  content: '';
  height: 100%;
  left: -45%;
  position: absolute;
  top: 0;
  width: 45%;
}
@keyframes pedido-linha-carregando {
  from {
    left: -45%;
  }
  to {
    left: 100%;
  }
}
@media (prefers-reduced-motion: reduce) {
  .pedido-etapa-linha.carregando::after {
    animation-duration: 2.8s;
  }

  .pedido-etapa.atual .pedido-etapa-icone > span {
    animation: none;
  }

  .pedido-etapa.atual.icone-delivery .pedido-etapa-icone::before {
    animation: none;
    display: none;
  }
}
.pedido-etapa-icone {
  align-items: center;
  background: #e9ecef;
  border: 4px solid #f8f9fa;
  border-radius: 50%;
  display: flex;
  font-size: 19px;
  height: 44px;
  justify-content: center;
  margin: 0 auto;
  position: relative;
  width: 44px;
  z-index: 1;
}
.pedido-etapa.concluida,
.pedido-etapa.atual {
  color: var(--lecard-primary);
}
.pedido-etapa.concluida .pedido-etapa-icone,
.pedido-etapa.atual .pedido-etapa-icone {
  background: var(--lecard-primary);
  color: #fff;
}
.pedido-etapa.atual .pedido-etapa-icone {
  box-shadow: 0 0 0 4px rgba(0, 0, 0, .04);
}
.pedido-etapa.atual .pedido-etapa-icone > span {
  transform-origin: center;
}
.pedido-etapa.atual.icone-pedido .pedido-etapa-icone > span {
  animation: pedido-icone-carimbo 1.6s ease-in-out infinite;
}
.pedido-etapa.atual.icone-local .pedido-etapa-icone > span {
  animation: pedido-icone-pulso 1.6s ease-in-out infinite;
}
.pedido-etapa.atual.icone-delivery .pedido-etapa-icone {
  overflow: hidden;
}
.pedido-etapa.atual.icone-delivery .pedido-etapa-icone::before {
  animation: pedido-icone-velocidade 1s linear infinite;
  background: rgba(255, 255, 255, .7);
  border-radius: 2px;
  box-shadow: 8px 6px 0 rgba(255, 255, 255, .45), -5px 12px 0 rgba(255, 255, 255, .6);
  content: '';
  height: 2px;
  left: 100%;
  position: absolute;
  top: 11px;
  width: 18px;
  z-index: 0;
}
.pedido-etapa.atual.icone-delivery .pedido-etapa-icone::after {
  background: var(--lecard-primary);
  border-radius: 50%;
  content: '';
  height: 28px;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 28px;
  z-index: 1;
}
.pedido-etapa.atual.icone-delivery .pedido-etapa-icone > span {
  position: relative;
  z-index: 2;
}
.pedido-etapa.atual.icone-sacola .pedido-etapa-icone > span {
  animation: pedido-icone-balanco 1.5s ease-in-out infinite;
}
@keyframes pedido-icone-carimbo {
  0%, 70%, 100% {
    transform: scale(1);
  }
  82% {
    transform: scale(.84);
  }
  91% {
    transform: scale(1.08);
  }
}
@keyframes pedido-icone-pulso {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.12);
  }
}
@keyframes pedido-icone-velocidade {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-66px);
  }
}
@keyframes pedido-icone-balanco {
  0%, 100% {
    transform: rotate(0);
  }
  30% {
    transform: rotate(-7deg);
  }
  70% {
    transform: rotate(7deg);
  }
}
.pedido-etapa-label {
  color: #495057;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.2;
  margin-left: -16px;
  margin-top: 8px;
  white-space: nowrap;
  width: 76px;
}
.pedido-etapa.atual .pedido-etapa-label,
.pedido-etapa.concluida .pedido-etapa-label {
  color: var(--lecard-primary);
}
.pedido-cancelado {
  color: #dc3545;
  text-align: center;
}
.pedido-cancelado-icone {
  align-items: center;
  background: var(--lecard-primary);
  border-radius: 50%;
  color: #fff;
  display: flex;
  font-size: 22px;
  height: 48px;
  justify-content: center;
  margin: 0 auto 10px;
  width: 48px;
}
.pedido-cancelado h6 {
  color: #dc3545;
  margin-bottom: 4px;
}
.pedido-cancelado p {
  color: #dc3545;
  font-size: 12px;
  margin-bottom: 0;
}
.pedido-horarios {
  background: #f8f9fa;
  border-radius: 8px;
  margin-top: 18px;
  padding: 8px 12px;
}
.pedido-horario {
  align-items: center;
  color: #adb5bd;
  display: flex;
  font-size: 13px;
  gap: 12px;
  justify-content: space-between;
  padding: 5px 0;
}
.pedido-horario span {
  font-weight: 600;
}
.pedido-horario time {
  color: #adb5bd;
  max-width: 58%;
  text-align: right;
}
.pedido-horario.concluido {
  color: #495057;
}
.pedido-horario.concluido time {
  color: #6c757d;
}
.pedido-detalhes {
  background: transparent;
  border: 0;
  border-top: 1px solid #e9ecef;
  color: #212529 !important;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  margin-top: 7px;
  padding: 12px 0 3px;
  text-align: center;
  width: 100%;
}
.pedido-detalhes i {
  color: #212529;
}
.pedido-detalhes-alternativo i {
  color: #212529;
}
.pedido-detalhes:focus {
  outline: none;
}
.whatsapp-alerta {
  border-top: 1px solid #e9ecef;
  padding-top: 24px;
}
</style>
